// Docs for react select box
// https://react-select.com/

import * as querystring from 'querystring'
import React from 'react'
import AsyncSelect from 'react-select/async'
import PropTypes from 'prop-types'
import styles from './master-form.module.css'

const getAddressUrl = '/.netlify/functions/address'

export default class StepBusinessDetailsAndAddress2 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      address: props.address,
      postcodeFromApi: '',
    }
  }

  getBusinessName(data) {
    if (data.sub_building_name) {
      if (!data.sub_building_name.toLowerCase().includes('flat') && !data.sub_building_name.toLowerCase().includes('apartment')) { // if the word 'flat' is included then it's probably not a business
        return data.sub_building_name
      }
    }
    return null
  }

  getStreet(data) {
    if (data.sub_building_name) {
      // there is a limited company name or flat number first
      return data.sub_building_name + ', ' + data.building_number + ' ' + data.thoroughfare
    }
    return data.building_number + ' ' + data.thoroughfare
  }

  getLabel(street, city) {
    return `${street}, ${city}`
  }

  async loadOptions(inputValue, callback) {
    if (inputValue.length < 4) return // postcodes aren't shorter than 4 characters

    // first save what's been entered, in case the address api is broken/down
    const justPostcodeAddress = { 
      postcode: inputValue,
      label: inputValue.toUpperCase(),
    }
    this.setState({
      ...this.state,
      address: justPostcodeAddress,
    })
    this.props.handleAddressChange(justPostcodeAddress)

    const body = querystring.stringify({
      postcode: inputValue,
    })
    const response = await fetch(getAddressUrl, { method: 'POST', body })
    
    if (response.ok) {
      const json = await response.json()

      // the response was good, meaning this must be a postcode
      // directly save the postcode typed, in case the user can't find their address from the list or they don't click anything
      const basicAddress = { 
        street: json.addresses?.[0]?.thoroughfare || null,
        city: json.addresses?.[0]?.town_or_city || null,
        postcode: json.postcode,
        label: json.postcode,
      }
      this.setState({
        ...this.state,
        address: basicAddress,
        postcodeFromApi: basicAddress.postcode,
      })
      this.props.handleAddressChange(basicAddress)

      // sort the addresses in building number order
      // get all options in the right format
      const allOptions = json.addresses.sort((a, b) => a.building_number - b.building_number).map((address) => ({
        value : address,
        label : this.getLabel(this.getStreet(address), address.town_or_city),
      }))

      // extract possible businesses from the data and push them to a new array
      const possibleBusinesses = []
      for (let i = allOptions.length - 1; i > 0; i--) {
        const option = allOptions[i]
        if (this.getBusinessName(option.value)) {
          possibleBusinesses.splice(0, 0, ...allOptions.splice(i, 1))
        }
      }

      callback([...possibleBusinesses, ...allOptions])
    }
  }

  handleInputChange(newValue) {
    return newValue
  }

  handleChange(data) {
    const address = {
      street: this.getStreet(data.value),
      city: data.value.town_or_city,
      postcode: this.state.postcodeFromApi,
    }
    address.businessName = this.getBusinessName(data.value)
    address.label = this.getLabel(address.street, address.city),
    this.setState({
      ...this.state,
      address,
    })
    this.props.handleAddressChange(address)
  }
  
  render() {
    return (
      <>
        <p className={styles.question}>What is your business&apos; <b>postcode</b>?</p>
        <div>
          <AsyncSelect
            id="postcode"
            placeholder={this.state.address?.label || 'Start typing...'}
            cacheOptions
            loadOptions={this.loadOptions.bind(this)}
            onInputChange={this.handleInputChange.bind(this)}
            onChange={this.handleChange.bind(this)}
          />
        </div>
      </>
    )
  }
}

StepBusinessDetailsAndAddress2.propTypes = {
  address: PropTypes.object.isRequired,
  handleAddressChange: PropTypes.func.isRequired,
}
